'use strict';

module.exports = {
    1: 'FIRST',
    2: 'SECOND',
    3: 'THIRD',
    4: 'FOURTH',
    5: 'FIFTH'
};